<script>
import Layout from "../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import appConfig from "@/../app.config";
import { required } from "vuelidate/lib/validators";
import uploadDocument from "../../../utils/digitalOcean/digitalocean-upload-file";
import CompanyItemsAPI from "@/services/items/companies_itemsAPI";
import proveedorContratistaAPI from "@/services/standards/crearProveedorContratista/proveedorContratistaAPI";
import Pagination from "@/components/standard/hazardIdentification/hazardPagination2";
import newScoresAPI from "../../../services/newScores/newScoresAPI"
import Swal from "sweetalert2";
import { sendNotification } from "@/utils/helpers/notification"
import CheckModal from "@/components/CheckModal"
import { dateFormat } from "@/utils/helpers/format";
import ItemAPI from "@/services/items/itemsAPI";
import revisionAnualAPI from "../../../services/standards/revisionAnual/revisionAnualAPI";
import ProveedoresEvaluacionPagination from "../../../components/standard/proveedoresEvaluacion/ProveedoresEvaluacionPagination.vue";
import proveedoresEvaluacionAPI from "../../../services/standards/proveedoresEvaluacion/proveedoresEvaluacionAPI";
/**
 * Form elements component
 */
export default {
  page: {
    title: "2.10.1 Evaluación y selección de proveedores y contratistas",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    Style,
    PageHeader,
    CheckModal,
    Pagination,
    ProveedoresEvaluacionPagination
  },
  data() {

    return {
      title: "2.10.1 Evaluación y selección de proveedores y contratistas",
      items: [

        {
          text: "Estandares",
          href: "/forms/estandares",
        },
        {
          text: "Evaluación y selección de proveedores",
          active: true,
        },
      ],

      colaboradorProveedor: [],
      lista: [],
      loading: true,
      loading2: true,
      acta: null,

      itemData: null,
      roleAdmin: true,

      item: null,
      itemStatus: "No cumplido",
      deleteCount: 0,
      search: "",

      itemData: null,

      file: null,

      evaluacionProveedores: {
        providers_contractors_id: null,
        companies_id: this.$store.getters["company/getCompany"].id || null,
        option: null,
        description: null,
        file: null,
        evaluated_last_year: null,
      },

      submitted: false,

      companyID: this.$store.getters["company/getCompany"].id || null,
      classificationID: this.$store.getters["company/getCompany"].company_classification_id || null,
      user: this.$store.state.auth || null,
      company: this.$store.getters["company/getCompany"] || null,
      nit: this.$store.getters["company/getCompany"].nit || null,

    };
  },

  validations: {
    evaluacionProveedores: {
      providers_contractors_id: {
        required,
      },
      option: {
        required,
      },
      description: {
        required,
      },
      evaluated_last_year: {
        required,
      },

    },
  },
  methods: {

    getItemData() {
      ItemAPI.getItems(21)
        .then((response) => {
          this.itemData = response;
          this.loading = false
        })
        .catch((error) => {
          console.log(error);
        });
    },

    allowAccess() {
      try {
        const item = this.itemData;
        if (item) {
          const classificationID =
            this.$store.getters["company/getCompany"].company_classification_id || null;
          if (classificationID === 1 && item.obligatory_UPA === 1) {
            return true;
          } else if (classificationID === 2 && item.obligatory_groupI === 1) {
            return true;
          } else if (classificationID === 3 && item.obligatory_groupII === 1) {
            return true;
          } else if (classificationID === 4 && item.obligatory_groupIII === 1) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    },

    goPage(page) {
      window.location.href = page
    },

    fetch() {
      this.$refs.paginator.query();
    },

    dateConvert(date) {
      return dateFormat(date);
    },

    getItems() {
      CompanyItemsAPI.getStatus(this.companyID, 21)
        .then(response => {
          this.item = response || null
          this.itemStatus = response.status !== undefined ? response.status : this.itemStatus;
        })
        .catch(error => {
          console.log(error)
        })
    },

    changeItemStatus(itemStatus) {
      const itemChange = {
        companies_id: this.companyID,
        item_id: 21,
        status: itemStatus,
      };
      newScoresAPI.calculateScores(itemChange)
        .then((response) => {
          Swal.fire({
            title: "¡Éxito!",
            text: "¡Se ha cambiado el estado del ítem con éxito!",
            icon: "success",
            type: "success",
            confirmButtonClass: "btn btn-confirm mt-2",
          });
          setTimeout(() => window.location.reload(), 1000)
        })
        .catch((error) => {
          Swal.fire({
            title: "¡ERROR!",
            text: "¡No se ha actualizado el estado del ítem!",
            icon: "error",
            type: "error",
            confirmButtonClass: "btn btn-confirm mt-2",
          });
          setTimeout(() => window.location.reload(), 1000)
          console.log(error);
        });
    },

    /**
         * This method is used to send notification to SST user and SST company.
         * The sendNotification method import is required.
         * @param {Number} messageID - The message ID that will be associated to notification.
         * @param {Number} itemID - The item ID that will be associated to notification.
         * @param {Boolean} user - The user that will e associated to notification.
         * @return {Boolean} True if the notification is sent, false if not.
         */
    sendNotification(messageID, itemID, user) {
      const company = this.$store.getters["company/getCompany"];
      return sendNotification(company.id, user ? company.id_diseno_sso : null, messageID, itemID);
    },


    /**
    * This method is used to knows if the user has the permission indicated
    * @param {String} name The name of the permission
    * @param {Array} roles the roles that permitted to access the action 
    * @returns {Boolean} true if the user has the permission indicated or false if no
    */
    getRole(name, roles) {

      // Get the user role
      let role = this.$store.state.auth.info.role ? this.$store.state.auth.info.role : null

      // If the user is logged
      if (role) {

        // If the roles array is not empty
        if (roles) {

          // Know if the role indicated is in the roles array
          role = roles.includes(role) ? true : false

        } // Close if the roles arrays is not empty

        // If the roles arrays is empty
        else {

          // Know if the user role is in the roles indicated
          role = role === 1 || role === 2 || role === 3 || role === 4 || role === 5 || role === 6 || role === 7 || role === 8
          if (role === 2) {
            this.roleAdmin = false
          }
        } // Close if the roles arrays is empty

        // Get the user permissions
        const permissions = this.$store.state.auth.info.permissions

        // Know if the user has the permission indicated
        const enabled = permissions.find(permission => permission.name === name)

        // If the user has the permission indicated and the user role is in the roles indicated
        return enabled && role ? true : false

      } // Close if the user is logged

      // If the user is not logged
      else {
        return false
      } // Close else the user is not logged
    },

    getPC() {
      proveedorContratistaAPI.getAll()
        .then((response) => {
          let proveedorC = response.data.data;
          this.colaboradorProveedor = proveedorC
          this.loading = false
        })
        .catch((error) => {
          console.log(error);
          this.loading = false
        });
    },

    /**
   * This method is used to redirect to the page indicated
   * @param {String} page The page to redirect
   */
    goPage(page) {
      window.location.href = page
    },

    async uploadFile() {
      this.file = this.$refs.file.files[0];
    },

    async uploadDocument() {
      try {
        let url = "";
        if (process.env.VUE_APP_ENV === 'development') {
          url = `sst-dev/${this.nit}/2.10.1/${this.evaluacionProveedores.providers_contractors_id}/${this.file.name}`;
        } else {
          url = `sst-prod/${this.nit}/2.10.1/${this.evaluacionProveedores.providers_contractors_id}/${this.file.name}`;
        }
        const result = await uploadDocument(url, this.file);
        if (result) {
          this.evaluacionProveedores.file = `${process.env.VUE_APP_BUCKET}/${url}`;
          return true;
        } else return false;
      } catch (error) {
        console.log(error);
      }
    },

    async save() {
      this.submitted = true;
      this.loading = true
      let response = await this.uploadDocument();
      if (response) {
        const data = {
          providers_contractors_id: this.evaluacionProveedores.providers_contractors_id,
          companies_id: this.companyID,
          option: this.evaluacionProveedores.option,
          description: this.evaluacionProveedores.description,
          file: this.evaluacionProveedores.file,
          evaluated_last_year: this.evaluacionProveedores.evaluated_last_year,
        };
        proveedoresEvaluacionAPI.save(data)
          .then((response) => {
            const itemChange = {
              companies_id: this.companyID,
              item_id: 21,
              status: 'Pendiente',
            };
            newScoresAPI.calculateScores(itemChange)
              .then((response) => {
                this.sendNotification(48, 21, true)
                this.sendNotification(49, 21, true)
                this.loading = false
                setTimeout(() => {
                  Swal.fire({
                    title: "¡Éxito!",
                    text: "¡Se ha registrado con éxito!",
                    type: "success",
                    icon: "success",
                    confirmButtonClass: "btn btn-confirm mt-2",
                  });
                  window.location.reload();
                }, 1000)
              })
              .catch((error) => {
                this.loading = false
                setTimeout(() => {
                  Swal.fire({
                    title: "Error",
                    text: "¡No se ha podido registrar!",
                    icon: "error",
                    type: "error",
                    confirmButtonClass: "btn btn-confirm mt-2",
                  });
                  window.location.reload();
                }, 1000);
                console.log(error);
              });
          })
          .catch((error) => {
            console.log(error);
            this.loading = false
          });
      } else {
        this.loading = false
        setTimeout(() => {
          Swal.fire({
            title: "¡No se ha podido registrar!",
            text: "¡No se ha podido registrar!",
            icon: "warning",
            confirmButtonClass: "btn btn-confirm mt-2",
          });
        }, 2000)
      }
    },

    deleteEvaluacion(id) {
      proveedoresEvaluacionAPI.delete(id)
        .then((data) => {
          if (this.deleteCount > 0) {
            this.deleteCount -= 1;
          }
          const newStatus = this.deleteCount > 0 ? 'Pendiente' : 'No Cumplido';
          const itemChange = {
            companies_id: this.companyID,
            item_id: 21,
            status: newStatus,
          };
          newScoresAPI.calculateScores(itemChange)
            .then((response) => {
              this.loading = false
              Swal.fire({
                title: "Éxito!",
                text: "Se ha sido eliminado con éxito!",
                icon: "success",
                type: "success",
                confirmButtonClass: "btn btn-confirm mt-2",
              });
              window.location.reload();
            })
            .catch((error) => {
              this.loading = false
              setTimeout(() => {
                Swal.fire({
                  title: "Error",
                  text: "¡No se ha podido registrar!",
                  icon: "error",
                  type: "error",
                  confirmButtonClass: "btn btn-confirm mt-2",
                });
                window.location.reload();
              }, 1000);
              console.log(error);
            });
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getActa() {
      revisionAnualAPI.getActa()
        .then((response) => {
          this.acta = response;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getList() {
      proveedoresEvaluacionAPI.getAll(this.companyID)
        .then((response) => {
          this.lista = response.data.data;
          if (Array.isArray(this.lista)) {
            this.deleteCount = this.lista.length;
          } else {
            this.deleteCount = 0;
          }
          this.loading = false
        })
        .catch((error) => {
          console.log(error);
        });
    },

    async print() {
      try {
        revisionAnualAPI.getActa()
          .then((response) => {
            this.acta = response;
          })
        const url = this.acta;
        window.location.href = url;
      } catch (error) {
        console.log(error);
      }
    },

    goBack() {
      this.$router.go(-1);
    },

    gotoDigitalOcean(url) {
      window.open(url);
    },

    async print1() {
      try {
        const url =
          "https://idmrnd3cibfs.compat.objectstorage.us-ashburn-1.oraclecloud.com/e-mision-sst/standards/PROCEDIMIENTO_SELECCION_EVALUACION_PYC.docx";
        window.location.href = url;
      } catch (error) {
        console.log(error);
      }
    },

  },

  mounted() {
    this.getActa();
    this.getItems();
    this.getList();
    this.getItemData();
    this.getPC();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-md-12">
        <div class="col-xl-12" v-if="!loading">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-md-6 col-sm-12">

                  <CheckModal>
                    <p class="text-justify">
                      En el Decreto 1072 de 2015 y en la Resolución 0312 de 2019 se solicita que la empresa cuente con
                      un procedimiento para la selección y evaluación de proveedores, el cual encontrará siguiendo el
                      link de procedimiento de selección y evaluación de proveedores.
                    </p>
                    <p class="text-justify">
                      Se deberá diligenciar el formato de selección de proveedores, indicando las empresas a las cuales
                      se le solicitó cotización y revisar los criterios de SST establecidos en el ítem 2.9.1, se
                      escogerá aquel proveedor que además de suplir las necesidades técnicas, garantice el cumplimiento
                      del SG SST.
                    </p>
                    <p class="text-justify">
                      Anualmente se deberá diligenciar el formato de evaluación de proveedores, midiendo el desempeño
                      del proveedor con respecto al SG SST.
                    </p>

                  </CheckModal>
                </div>
                <div class="form-row col-md-6 col-sm-12 pt-1">
                  <b-form-group id="statusInput" label-for="statusInput" class="col-sm-12" label="Estado del ítem">
                    <b-form-select v-on:change="changeItemStatus(itemStatus)"
                      :disabled="!getRole('Actualizar items', [1, 2, 3]) || !item || !allowAccess()" plain
                      class="selectpicker form-control" v-model="itemStatus">
                      <b-form-select-option value="Aprobado">Aprobado</b-form-select-option>
                      <b-form-select-option value="Pendiente">Pendiente</b-form-select-option>
                      <b-form-select-option value="No cumplido">No cumplido</b-form-select-option>
                    </b-form-select>
                  </b-form-group>
                </div>

              </div>

              <div class="row pt-3">
                <div class="col-12 text-right mb-3 mt-2 ">
                  <button :disabled="roleAdmin && !allowAccess()" @click="
                    goPage(`/forms/estandares/${companyID}/crear-colaborador`)" class="btn btn-primary mx-1"
                    id="tooltip">
                    <span class="btn-label m-0"> Crear proveedor o contratista</span>
                  </button>

                  <b-tooltip target="tooltip" placement="left">
                    Crear proveedor
                  </b-tooltip>
                </div>

                <div class="col-12 text-right m-b-0">
                  <button :disabled="!allowAccess()" @click="print1" class="btn btn-primary mx-1">
                    <span class="btn-label">
                      <i class="bx bx-download"></i></span>
                    Procedimiento de Selección y Evaluación de Proveedores y Contratistas
                  </button>
                </div>
              </div>
              <hr />

              <form class="form-group" @submit.prevent="save">
                <div class="form-row pt-3">
                  <b-form-group label-for="employee" class="col-md-6 px-2 mb-3" label="Seleccionar proveedor">
                    <select :disabled="!getRole('Crear') || !allowAccess()" class="form-control"
                      v-model="evaluacionProveedores.providers_contractors_id"
                      :class="{ 'is-invalid': $v.evaluacionProveedores.providers_contractors_id.$error && submitted }">
                      <b-form-select-option v-for="item in colaboradorProveedor" :key="item.id" :value="item.id">
                        {{ item.name }} - {{ item.type }}
                      </b-form-select-option>
                    </select>
                    <div v-if="submitted && $v.evaluacionProveedores.providers_contractors_id.$error">
                      <small v-if="!$v.evaluacionProveedores.providers_contractors_id.required" class="text-danger">
                        <b>El proveedor es requerido</b>
                      </small>
                    </div>
                  </b-form-group>

                  <div class="col-6 text-align-center mt-3">
                    <b-form-group label-for="¿Evaluada el ultimo año?" inline class="text-align-center mt-3 mb-3">
                      <label class="mr-2">Producto</label>
                      <input type="radio" :disabled="!getRole('Crear') || !allowAccess()" value="Producto"
                        v-model="evaluacionProveedores.option" class="" label="accidente" />
                      <label class="mr-2 ml-5">Servicio</label>
                      <input type="radio" :disabled="!getRole('Crear') || !allowAccess()" value="Servicio"
                        v-model="evaluacionProveedores.option" class="" label="incidente" />

                      <div v-if="submitted && $v.evaluacionProveedores.option.$error">
                        <small v-if="!$v.evaluacionProveedores.option.required" class="text-danger">
                          <b>Seleccionar una opción</b>
                        </small>
                      </div>
                    </b-form-group>
                  </div>

                  <b-form-group class="col-md-12 px-2" label="Descripción del producto o servicio"
                    label-for="trainingDate">
                    <b-form-textarea :disabled="!allowAccess() || !getRole('Crear')" id="trainingDate"
                      v-model="evaluacionProveedores.description" maxlength="400"
                      :class="{ 'is-invalid': $v.evaluacionProveedores.description.$error && submitted }">
                      >
                    </b-form-textarea>
                    <div v-if="submitted && $v.evaluacionProveedores.description.$error">
                      <small v-if="!$v.evaluacionProveedores.description.required" class="text-danger">
                        <b>La descripción es requerida</b>
                      </small>
                    </div>
                  </b-form-group>

                  <b-form-group class="col-md-8 pt-2" label="Subir evidencia de selección" label-for="file">
                    <b-form-file :disabled="!getRole('Crear') || !allowAccess()" type="file" id="file" ref="file"
                      name="file" browse-text="Buscar" :placeholder="`Selecciona un archivo...`"
                      drop-placeholder="Suelta acá..." v-model="file" @change="uploadFile" v-on:change="uploadFile"
                      accept=".doc,.pdf, .xlsx, .xls, .docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document">
                    </b-form-file>
                  </b-form-group>

                  <b-form-group label="¿Evaluada el ultimo año?" label-for="¿Evaluada el ultimo año?" inline
                    class="col-sm-4 pl-5 pt-3">
                    <label class="mr-2">
                      Si
                    </label>
                    <input type="radio" style="color: #666" :value="1"
                      v-model="evaluacionProveedores.evaluated_last_year" class="mb-2 mr-sm-2 mb-sm-0"
                      label="accidente" />
                    <label class="mr-2 pl-sm-2 pl-md-0">
                      No
                    </label>
                    <input type="radio" :value="2" v-model="evaluacionProveedores.evaluated_last_year"
                      class="mb-2 mr-sm-2 mb-sm-0" label="incidente" />
                    <div v-if="submitted && $v.evaluacionProveedores.evaluated_last_year.$error">
                      <small v-if="!$v.evaluacionProveedores.evaluated_last_year.required" class="text-danger">
                        <b>Seleccionar una opción</b>
                      </small>
                    </div>
                  </b-form-group>

                </div>

                <div class="form-group text-right m-b-0">
                  <button :disabled="submitted" type="submit" class="btn btn-primary">Guardar</button>
                  <button type="button" class="btn btn-secondary mx-1" @click="goBack">
                    Cancelar
                  </button>
                </div>

                <hr v-if="getRole('Consultar')" />

                <div class="row" v-if="getRole('Consultar') || !allowAccess()">
                  <div class="col-lg-12">
                    <div class="card-body">
                      <div class="row pb-3">
                        <div class="col-6">
                          <form @submit.prevent="fetch()" class="form-inline">
                            <div class="form-group mr-2">

                              <b-form-input type="text" name="search" id="search" v-model="search" @update="fetch()"
                                class="form-control px-2" placeholder="Buscar"></b-form-input>

                              <div class="col-1">
                                <button type="submit" class="btn btn-primary px-2">Buscar</button>
                              </div>
                            </div>
                          </form>
                        </div>
                        <div class="col-6"></div>
                      </div>

                      <div class="table-responsive">
                        <table class="pt-2 table border-bottom divide-y divide-gray-200 table-striped rounded">
                          <thead>
                            <tr>
                              <th class="text-center align-middle">Fecha</th>
                              <th class="text-center align-middle">Empresa seleecionada</th>
                              <th class="text-center align-middle">¿Evaluada el ultimo año?</th>
                              <th class="text-center align-middle">Ver archivo</th>
                              <th class="text-center align-middle">Acciones</th>
                            </tr>
                          </thead>
                          <tbody class="bg-white divide-y divide-gray-200">
                            <tr v-for="dato in lista" :key="dato.id">
                              <td class="text-center align-middle">
                                {{ dateConvert(dato.created_at) }}
                              </td>
                              <td class="text-center align-middle">
                                {{ dato.name }}
                              </td>
                              <td class="text-center align-middle">
                                {{ dato.evaluated_last_year }}
                              </td>

                              <td class="text-center align-middle">
                                <div v-if="dato.file === null">
                                  <h6>No hay archivo disponible
                                  </h6>
                                </div>
                                <div v-else>
                                  <button :disabled="!allowAccess()"
                                    style=" background-color: transparent !important; border: none;" type="button"
                                    @click="gotoDigitalOcean(`${dato.file}`)"> <i class="mdi mdi-cloud-download"></i>
                                  </button>
                                </div>
                              </td>

                              <td class="text-center align-middle">
                                <div class="col-sm-12">
                                  <b-dropdown :disabled="!allowAccess()" variant="primary">
                                    <template v-slot:button-content>
                                      <i class="mdi mdi-eye"></i>
                                    </template>
                                    <b-dropdown-item :disabled="!getRole('Editar') || !allowAccess()"
                                      :to="{ path: `/forms/estandares/evaluacion-seleccion-proveedores-ver/${dato.id}` }">
                                      Ver</b-dropdown-item>
                                    <b-dropdown-item :disabled="!getRole('Editar') || !allowAccess()"
                                      v-b-modal="`modal${dato.id}`">Editar</b-dropdown-item>

                                    <b-modal :id="`modal${dato.id}`" body-class="p-4" hide-header hide-footer size="sm">
                                      <div class="text-justify">
                                        <h4 class="mt-2 text-primary text-center">Advertencia</h4>
                                        <p class="mt-3">
                                          Al modificar esta información se quitará el puntaje correspondiente
                                          a este ítem y será necesario realizar nuevamente la validación por
                                          parte del usuario responsable de Emisión.
                                        </p>
                                        <button :disabled="!getRole('Editar') || !allowAccess()" type="button"
                                          class="btn btn-primary my-2 mx-2">
                                          <router-link class="text-white"
                                            :to="{ path: `/forms/estandares/evaluacion-seleccion-proveedores-editar/${dato.id}` }">Editar
                                          </router-link>
                                        </button>
                                        <button type="button" @click="$bvModal.hide(`modal${dato.id}`)"
                                          class="btn btn-danger btn mx-2" data-dismiss="modal">Cancelar
                                        </button>
                                      </div>
                                    </b-modal>
                                    <b-dropdown-item :disabled="!getRole('Editar') || !allowAccess()"
                                      :to="{ path: `/forms/estandares/evaluacion-seleccion-proveedores2.10.1-1/${dato.id}` }">
                                      Evaluación</b-dropdown-item>

                                    <b-dropdown-item v-if="dato.initial_date === null"
                                      :disabled="!getRole('Eliminar') || !allowAccess()"
                                      v-on:click="deleteEvaluacion(dato.id)">Eliminar</b-dropdown-item>
                                  </b-dropdown>
                                </div>
                              </td>
                            </tr>

                          </tbody>
                        </table>
                        <ProveedoresEvaluacionPagination ref="paginator" :search="search"
                          @fetch="(items) => (lista = items)" />

                      </div>
                    </div>
                  </div>
                  <!-- end col -->
                </div>
              </form>
            </div>
          </div>

        </div>

        <div v-else class="col-xl-12 text-center">
          <div class="text-center">
            <b-spinner variant="primary" label="Loading..."></b-spinner>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.background-modal {
  background-color: transparent !important;
  border: none;
}
</style>